import { Settings as SettingsIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";

export const AboutSection = () => (
  <Card className="card-surface" data-testid="about-card">
    <CardHeader style={{ borderBottom: '1px solid var(--t-border)', padding: '16px 20px' }}>
      <div className="flex items-center gap-3">
        <SettingsIcon className="w-5 h-5" style={{ color: 'var(--t-text-muted)' }} />
        <div>
          <CardTitle className="text-lg font-semibold" style={{ color: 'var(--t-text)', fontFamily: 'var(--t-heading-font)' }}>
            About
          </CardTitle>
          <CardDescription style={{ color: 'var(--t-text-muted)' }}>Application information</CardDescription>
        </div>
      </div>
    </CardHeader>
    <CardContent className="p-5">
      <div className="space-y-2 text-sm">
        <p><span style={{ color: 'var(--t-text-muted)' }}>Application:</span> <span className="font-medium" style={{ color: 'var(--t-text)' }}>MattC Transaction Manager</span></p>
        <p><span style={{ color: 'var(--t-text-muted)' }}>Version:</span> <span className="font-medium" style={{ color: 'var(--t-text)' }}>1.2.0</span></p>
      </div>
    </CardContent>
  </Card>
);
